export default {
    calendar:{
        today: 'Сегодня',
    }
}